const getEnvironmentVariable = (key: string): string | undefined => {
  const value = process.env[key];
  return typeof value === "string" && value.length > 0 ? value : undefined;
};

export const getRequiredEnvVar = (key: string): string => {
  const value = getEnvironmentVariable(key);
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
};

export const getOptionalEnvVar = (key: string): string | undefined =>
  getEnvironmentVariable(key);

export const getOptionalEnvArray = (key: string): string[] | undefined => {
  const value = getEnvironmentVariable(key);
  if (!value) {
    return undefined;
  }

  return value
    .split(/[;,\s]+/)
    .map((entry) => entry.trim())
    .filter(Boolean);
};
